
$(document).ready(function(){   

  var h_top = $('.header_top').outerHeight();
  $(window).scroll(function(){



    if ($(window).scrollTop() >= h_top ) {
      $('.site-header').addClass('fixed-header'); 
      $('.category_section').addClass('fixed_category');    
      var header_section = $('.header_bottom').outerHeight(); 
      // $(".category_section").css("top", header_section );

    }
    else {
      $('.site-header').removeClass('fixed-header'); 
      $('.category_section').removeClass('fixed_category'); 

      //     $(".category_section").css("top", 'inherit' );
    }

  });

  var cat_height = $('.category_section').outerHeight();
  var header_height = $('.site-header').outerHeight();
  var top_total = header_height + cat_height;
  $('main.main-content').css('padding-top',top_total);

  $(window).resize(function(){
    var cat_height = $('.category_section').outerHeight();
    var header_height = $('.site-header').outerHeight();
    var top_total = header_height + cat_height;
    $('main.main-content').css('padding-top',top_total);  
  });

  $('.user_logout svg').on("click", function (e) {
    $('.user_account').slideToggle();
    $('.search-bar').hide(); 
    e.preventDefault();
    e.stopPropagation();
  });

  $('.user_account').on("click", function (e) {
    e.stopPropagation();
  });

  $(document).on("click", function () { 
    $('.user_account').hide(); 

    setTimeout(function(){                                  
      var window_height = $(window).height();
      var cart_b_height = $('.cart_bottom_section').outerHeight();
      var total = window_height - cart_b_height;
      $('.cart__body').css('height',total - 105);
    }, 3000);

  });

  $('.menu_toggle').on('click',function(){
    $('html').toggleClass('open_menu_overlay');  
  });

  $('.menu_close,.menu_right_overlay').on('click',function(){
    $('html').removeClass('open_menu_overlay');  
  });

  /* Homepage Slider */
  $('.featured_product_slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    draggable: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {        
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1200,
        settings: {        
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {        
          slidesToShow: 2
        }
      },
      {
        breakpoint: 568,
        settings: {        
          slidesToShow: 1
        }
      }
    ]
  });

  /*----- Quantity code for cart page ------*/  

  //   $(".quantity_selector").append('<div class="inc button"><span>+</span></div><div class="dec button"><span>-</span></div>');
  //   $(".button").on("click", function () {
  //     var $button = $(this);
  //     var oldValue = $button.parent().find("input").val();
  //     if (oldValue === "") {
  //       oldValue = 0;
  //     }
  //     if ($button.text() === "+") {
  //       var newVal = parseFloat(oldValue) + 1;
  //     } else {
  //       // Don't allow decrementing below zero
  //       if (oldValue > 0) {
  //         var newVal = parseFloat(oldValue) - 1;
  //       } else {
  //         newVal = 0;
  //       }
  //     }
  //     $button.parent().find("input").val(newVal);
  //   });

  /*---- product detail slider -----*/
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable:false,
    asNavFor: '.slider-nav',  
    infinite: false
  });

  $('.slider-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,   
    focusOnSelect: true, 
    vertical: true,
    verticalSwiping: false, 
    infinite: false,
    draggable:false,   
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1           
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1         
        }
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1 
        }
      } ,
      {
        breakpoint: 120,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1         
        }
      }
    ]
  }); 
  /*----- qickview popup  ------*/  
  $(".quickview_btn").on("click", function() { 
    var modal = $(this).data("modal");
    $(modal).show(); 
   
    $('html').toggleClass('model_open');   
    $(this).parents( ".featured_product_slider").children(".slick-list").children('.slick-track').addClass('transform');
debugger;
    
      $(modal).children('.model_content').css('width',$(modal).outerWidth());
     $( ".quick_slider" ).slick("setPosition", 0);    
    $( ".quick_slider2" ).slick("setPosition", 0);
  });      

  $('.close_popup').click(function () { 
    $('.model_box').hide();
    $('html').removeClass('model_open');
    $(this).parents( ".featured_product_slider").children(".slick-list").children('.slick-track').removeClass('transform');
  });
  $(".model_box").on("click", function(e) {
    var className = e.target.className;
    if(className === "model_box" ){
      $(this).closest(".model_box").hide();
      $('html').removeClass('model_open');
      $(this).parents( ".featured_product_slider").children(".slick-list").children('.slick-track').removeClass('transform');
    }
  }); 



  $(document).on("click", ".cart_drawer_close", function () { 
    $('body').removeClass('cart-drawer-visible');
    $('.ajaxify-drawer').removeClass('is-visible'); 
  });

  $(document).on('click', '.filter_menu a', function () {
    $('.collection_sidebar').animate({left: '0'});
    $('body').addClass('collection-filter');
  });
  $('.filter_colse,.filter-overlay').on("click", function () {
    var collection_sidebar = $('.collection_sidebar').outerWidth();
    $('.collection_sidebar').animate({left: -collection_sidebar});
    $('body').removeClass('collection-filter');
  });


  $(".quick_slider").slick({
    slidesToShow: 1,    
    slidesToScroll: 1,
    fade: true,
    draggable: false,
    arrows:false,
    asNavFor: ".quick_slider2"
  });
  $(".quick_slider2").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".quick_slider",
    dots: false,
    focusOnSelect: true,
    //      vertical: true,
    //      verticalSwiping:false,
    infinite: false,
    draggable: false,
    responsive: [{
      breakpoint: 575,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 420,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 120,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }]
  });

  $( window ).resize(function() {
    var window_height = $(window).height();
    var cart_b_height = $('.cart_bottom_section').outerHeight();
    var total = window_height - cart_b_height;
    $('.cart__body').css('height',total - 105);
  });

  if ($(window).width() < 1024) {      

    $(".category_link").on("click", function (e) {     
      
      e.preventDefault();
      e.stopPropagation();
      if($(this).next().length > 0){
        if ($(window).width() < 1024) {  
          $('ul.category_menu').hide();
          $('.category_section').removeClass('open');

          $('.category_link').removeClass('important');
          if (!$(e.target).closest('ul').is('.category_menu')) {
            e.preventDefault(); 

            if (!$(this).hasClass('important')) {
              $(this).addClass('important');
              $(this).next().slideToggle();
              
              var html =  $(this).next().html();
              $('.category_append_mobile').html('<ul class="category_menu">' + html + '</ul>');
              $('.category_section').addClass('open');
              //toggle the menu 
            } else {
              //redirect if second click 
              window.location = $(this).attr('href');
            }
          }
        }
      }
    });

    $('ul.category_menu').on("click", function (e) {
      e.stopPropagation();
    });


    $(document).on("click", function () { 
      $('ul.category_menu').hide();
      $('.category_section').removeClass('open'); 
      $('.category_append_mobile').html('')
    });

  }

    setTimeout(function(){    
  var highestBox = 0;
  $('.product-grid-item').each(function(){  
    if($(this).height() > highestBox){  
      highestBox = $(this).height();  
    }
  });    
  $('.product-grid-item').height(highestBox);
  }, 1000);
  
  


        $('.search-bar').submit(function () {
          debugger;
          	var self = this;
          	event.preventDefault ? event.preventDefault() : event.returnValue = false;
          
            var searchfield = $('.search_input');
            searchfield.val("*" + searchfield.val() + "*");
          
          	 self.submit();
        });


  
});



